import React, { useState } from "react";
import { storeQuoteRequest } from 'API/index';

const GetQuote = () => {
  const [formData, setFormData] = useState({
    name: "",
    make: "",
    model: "",
    year: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      await storeQuoteRequest(formData);
    } catch (err) {
      console.error(err.message);
    }






    alert("Quote request sent! Our mechanic will contact you soon.");

    setFormData({
      name: "",
      make: "",
      model: "",
      year: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  return (
    <section className="mx-auto mt-10 w-full max-w-3xl rounded-2xl bg-white p-6 shadow-sm">
      <h2 className="text-2xl font-semibold text-gray-900">
        Get a Quote
      </h2>
      <p className="mt-1 text-sm text-gray-600">
        Tell us about your vehicle and what you need. Our mechanic will send you a quote.
      </p>

      <form onSubmit={handleSubmit} className="mt-6 space-y-5">

        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Full Name
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="input border border-gray-300 rounded-md"
            placeholder="John Doe"
            required
          />
        </div>


        <div className="grid gap-4 sm:grid-cols-3">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Make
            </label>
            <input
              type="text"
              name="make"
              value={formData.make}
              onChange={handleChange}
              className="input border border-gray-300 rounded-md"
              placeholder="Audi"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Model
            </label>
            <input
              type="text"
              name="model"
              value={formData.model}
              onChange={handleChange}
              className="input border border-gray-300 rounded-md"
              placeholder="A4"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Year
            </label>
            <input
              type="number"
              name="year"
              value={formData.year}
              onChange={handleChange}
              className="input border border-gray-300 rounded-md"
              placeholder="2017"
              required
            />
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="input border border-gray-300 rounded-md"
              placeholder="john@example.com"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Phone
            </label>
            <input
              type="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="input border border-gray-300 rounded-md"
              placeholder="1231231232"
              required
            />
          </div>
        </div>




        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Describe the issue or service you need
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={4}
            className="input w-full border border-gray-300 rounded-md"
            placeholder="Example: My car makes a rattling noise when braking..."
            required
          />
        </div>


        <div className="pt-2">
          <button
            type="submit"
            className="rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-500"
          >
            Send Quote Request
          </button>
        </div>
      </form>
    </section>
  );
};

export default GetQuote;
